import React from "react";
import css from "./DefaultConfigSection.module.css";
import {capitalize} from "vritra";
import {Badge,TerminalView,FileNavigator,FileView,NoticeView,TextView,SectionView} from "Components";
import {arrow0,book0} from "Assets";


export default function DefaultConfigSection(){
    return (
        <SectionView 
            className={css.defaultconfigsection}
            title="default configuration"
        >
            <div className={css.configdetails}>
                <SectionView title="import aliases">
                    <ul className={css.aliases}>
                        {statics.aliases.map(alias=>(
                            <li key={alias.name}>
                                {alias.name} <img src={arrow0(minorColor)}/> {alias.path}
                                {statics.envs.map(({id})=>alias[id+`only`]&&
                                    <Badge key={id} className={css.envbadge} text={`${id} only`}/>
                                )}
                            </li>
                        ))}
                    </ul>
                </SectionView>
                <SectionView 
                    title="definitions"
                    text={`
                        <a href="https://webpack.js.org/plugins/define-plugin/"
                        >definitions</a> are variables that you can use inside your code without
                        the need of declaring them. 
                        @those variables are recognized by webpack
                        and replaced with other values or expressions at compile time.
                        @the vritra-scripts package has already defined three variables for
                        you to use inside your code:
                    `}
                >
                    <ul className={css.definitions}>
                        {statics.envs.map(({id,name})=>(
                            <li key={id}>
                                {"is"+capitalize(id)+"Env"}: 
                                <span> true</span> in {name} mode, <span>false</span> otherwise
                            </li>
                        ))}
                    </ul>
                    <FileView content={statics.dataFetchCode.source}/>
                    <TextView>
                        Because the values of these variables are pre-known 
                        at compile time, Webpack will adjust your code accordingly:
                    </TextView>
                    <FileNavigator files={[
                        {name:"Development",content:statics.dataFetchCode.dev},
                        {name:"Testing",content:statics.dataFetchCode.test},
                        {name:"Production",content:statics.dataFetchCode.prod},
                    ]}/>
                </SectionView>
                <SectionView 
                    title="servers"
                    text={`
                        The vritra-scripts package use different servers for the 
                        development and testing modes.
                    `}
                >
                    <ul className={css.servers}>
                        <li>
                            <span>Webpack server</span> for the development mode through :
                            <TerminalView 
                                style={{fontSize:"0.3em"}} 
                                lines={["npm start"]}
                            />
                        </li>
                        <li>
                            <span>Phonegap server</span> for the testing mode through :
                            <TerminalView 
                                style={{fontSize:"0.3em"}} 
                                lines={["npm start -- --env=test"]}
                            />
                        </li>
                    </ul>
                    <NoticeView icon={book0}>{`
                        The Phonegap server <b>allows</b> by default requests over 
                        <b>http</b> so you can connect your app to your testing server.
                    `}</NoticeView>
                </SectionView>
            </div>
        </SectionView>
    )
}

const statics={
    aliases:[
        {
            name:"assets",
            path:"src/Assets/index.js",
        },
        {
            name:"localdb",
            path:"src/LocalDB/index.js",
            devonly:true,
        },
        {
            name:"actions",
            path:"src/Store/Actions/index.js",
        },
        {
            name:"screens",
            path:"src/Screens/index.js",
        },
        {
            name:"resources",
            path:"src/Resources/index.js",
        },
        {
            name:"components",
            path:"src/Components/index.js",
        },
    ],
    envs:[
        {id:"dev",name:"development"},
        {id:"test",name:"testing"},
        {id:"prod",name:"production"}
    ],
    dataFetchCode:{
        dev:'<div><span style="color: #c586c0;">import</span> <span style="color: #569cd6;">*</span> <span style="color: #c586c0;">as</span> <span style="color: #9cdcfe;">localdb</span> <span style="color: #c586c0;">from</span> <span style="color: #ce9178;">"localdb"</span>;</div><br><br><div><span style="color: #569cd6;">const</span> <span style="color: #dcdcaa;">fetchData</span>=()<span style="color: #569cd6;">=&gt;new</span> <span style="color: #4ec9b0;">Promise</span>(<span style="color: #dcdcaa;">resolve</span><span style="color: #569cd6;">=&gt;</span>{</div><div>    <span style="color: #dcdcaa;">setTimeout</span>(()<span style="color: #569cd6;">=&gt;</span>{</div><div>        <span style="color: #dcdcaa;">resolve</span>(<span style="color: #9cdcfe;">localdb</span>.<span style="color: #9cdcfe;">somedata</span>);</div><div>    },<span style="color: #b5cea8;">300</span>);</div><div>}).</div><div><span style="color: #dcdcaa;">catch</span>(<span style="color: #9cdcfe;">error</span><span style="color: #569cd6;">=&gt;</span>{</div><div>    <span style="color: #6a9955;">/* Handle error */</span></div><div>});</div>',
        test:'<div><span style="color: #569cd6;">const</span> <span style="color: #dcdcaa;">fetchData</span>=()<span style="color: #569cd6;">=&gt;new</span> <span style="color: #4ec9b0;">Promise</span>(<span style="color: #dcdcaa;">resolve</span><span style="color: #569cd6;">=&gt;</span>{</div><div>    <span style="color: #dcdcaa;">resolve</span>(<span style="color: #dcdcaa;">fetch</span>(<span style="color: #ce9178;">`http://testServerAddress/yourDataEndpoint`</span>));</div><div>}).</div><div><span style="color: #dcdcaa;">catch</span>(<span style="color: #9cdcfe;">error</span><span style="color: #569cd6;">=&gt;</span>{</div><div>    <span style="color: #6a9955;">/* Handle error */</span></div><div>});</div>',
        prod:'<div><span style="color: #569cd6;">const</span> <span style="color: #dcdcaa;">fetchData</span>=()<span style="color: #569cd6;">=&gt;new</span> <span style="color: #4ec9b0;">Promise</span>(<span style="color: #dcdcaa;">resolve</span><span style="color: #569cd6;">=&gt;</span>{</div><div>    <span style="color: #dcdcaa;">resolve</span>(<span style="color: #dcdcaa;">fetch</span>(<span style="color: #ce9178;">`https://prodServerAddress/yourDataEndpoint`</span>));</div><div>}).</div><div><span style="color: #dcdcaa;">catch</span>(<span style="color: #9cdcfe;">error</span><span style="color: #569cd6;">=&gt;</span>{</div><div>    <span style="color: #6a9955;">/* Handle error */</span></div><div>});</div>',
        source:'<div><span style="color: #c586c0;">import</span> <span style="color: #569cd6;">*</span> <span style="color: #c586c0;">as</span> <span style="color: #9cdcfe;">localdb</span> <span style="color: #c586c0;">from</span> <span style="color: #ce9178;">"localdb"</span>;</div><br><br><div><span style="color: #569cd6;">const</span> <span style="color: #dcdcaa;">fetchData</span><span style="color: #d4d4d4;">=</span>()<span style="color: #569cd6;">=&gt;new</span> <span style="color: #4ec9b0;">Promise</span>(<span style="color: #dcdcaa;">resolve</span><span style="color: #569cd6;">=&gt;</span>{</div><div>&nbsp; &nbsp; <span style="color: #c586c0;">if</span>(<span style="color: #9cdcfe;">isDevEnv</span>){</div><div>&nbsp; &nbsp; &nbsp; &nbsp; <span style="color: #dcdcaa;">setTimeout</span>(()<span style="color: #569cd6;">=&gt;</span>{</div><div>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <span style="color: #dcdcaa;">resolve</span>(<span style="color: #9cdcfe;">localdb</span>.<span style="color: #9cdcfe;">somedata</span>);</div><div>&nbsp; &nbsp; &nbsp; &nbsp; },<span style="color: #b5cea8;">300</span>);</div><div>&nbsp; &nbsp; }</div><div>&nbsp; &nbsp; <span style="color: #c586c0;">else</span>{</div><div>&nbsp; &nbsp; &nbsp; &nbsp; <span style="color: #dcdcaa;">resolve</span>(<span style="color: #dcdcaa;">fetch</span>(<span style="color: #ce9178;">`http</span><span style="color: #569cd6;">${</span><span style="color: #9cdcfe;">isProdEnv</span><span style="color: #d4d4d4;">?</span><span style="color: #ce9178;">"s"</span><span style="color: #d4d4d4;">:</span><span style="color: #ce9178;">""</span><span style="color: #569cd6;">}</span><span style="color: #ce9178;">://</span><span style="color: #569cd6;">${</span><span style="color: #9cdcfe;">isTestEnv</span><span style="color: #d4d4d4;">?</span><span style="color: #ce9178;">"testServerAddress"</span><span style="color: #d4d4d4;">:</span><span style="color: #ce9178;">"prodServerAddress"</span><span style="color: #569cd6;">}</span><span style="color: #ce9178;">/yourDataEndpoint`</span>));</div><div>&nbsp; &nbsp; }</div><div>}).</div><div><span style="color: #dcdcaa;">catch</span>(<span style="color: #9cdcfe;">error</span><span style="color: #569cd6;">=&gt;</span>{</div><div>&nbsp; &nbsp; <span style="color: #6a9955;">/* Handle error */</span></div><div>});</div>',
    },
}
